"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "m16 16.5-4-4-4 4V20h8z",
  opacity: ".3"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "m16 16.5-4-4-4 4V20h8z",
  opacity: ".3"
}, "1"), /*#__PURE__*/_jsx("path", {
  d: "M6 22h12v-6l-4-4 3.99-4.01L18 2H6l.01 5.99L10 12l-4 3.99zM8 7.5V4h8v3.5l-4 4zm0 9 4-4 4 4V20H8z"
}, "2")], 'HourglassBottomTwoTone');